import { render, staticRenderFns } from "./PaginationTable.vue?vue&type=template&id=b5663c3e&"
import script from "./PaginationTable.vue?vue&type=script&lang=js&"
export * from "./PaginationTable.vue?vue&type=script&lang=js&"
import style0 from "./PaginationTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports